import React from 'react';
import { useTranslation } from 'react-i18next';
import Header from '../components/Header';
import Footer from '../components/Footer';
import { Shield } from 'lucide-react';
import SafeHTML from '../components/SafeHTML';

const PrivacyPolicyPage = () => {
  const { t } = useTranslation();
  return (
    <div className="min-h-screen bg-gray-50">
      <Header />
      
      {/* Hero Section */}
      <section className="bg-gradient-to-r from-logo-blue to-logo-cyan py-16">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
          <div className="inline-flex items-center justify-center w-20 h-20 bg-white/20 rounded-full mb-6">
            <Shield className="w-10 h-10 text-white" />
          </div>
          <h1 className="text-4xl lg:text-5xl font-bold text-white mb-4">
            {t('privacyTitle')}
          </h1>
          <p className="text-lg text-white/90">
            {t('privacySubtitle')}
          </p>
        </div>
      </section>

      {/* Content Section */}
      <section className="py-16">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="bg-white rounded-2xl shadow-lg p-8 lg:p-12">
            
            <div className="prose prose-lg max-w-none">
              <SafeHTML tag="p" className="text-gray-700 leading-relaxed mb-8" html={t('privacyIntro')} />

              <h2 className="text-2xl font-bold text-gray-900 mb-4 mt-8">
                {t('privacySection1Title')}
              </h2>
              <p className="text-gray-700 leading-relaxed mb-6">
                {t('privacySection1Content')}
              </p>

              <h2 className="text-2xl font-bold text-gray-900 mb-4 mt-8">
                {t('privacySection2Title')}
              </h2>
              <p className="text-gray-700 leading-relaxed mb-4">
                {t('privacySection2Intro')}
              </p>
              <ul className="list-disc pl-6 mb-6 text-gray-700 space-y-2">
                <li>{t('privacySection2Item1')}</li>
                <li>{t('privacySection2Item2')}</li>
                <li>{t('privacySection2Item3')}</li>
              </ul>

              <h2 className="text-2xl font-bold text-gray-900 mb-4 mt-8">
                {t('privacySection3Title')}
              </h2>
              <p className="text-gray-700 leading-relaxed mb-6">
                {t('privacySection3Content')}
              </p>

              <h2 className="text-2xl font-bold text-gray-900 mb-4 mt-8">
                {t('privacySection4Title')}
              </h2>
              <p className="text-gray-700 leading-relaxed mb-6">
                {t('privacySection4Content')}
              </p>

              <h2 className="text-2xl font-bold text-gray-900 mb-4 mt-8">
                {t('privacySection5Title')}
              </h2>
              <p className="text-gray-700 leading-relaxed mb-6">
                {t('privacySection5Content')}
              </p>

              <h2 className="text-2xl font-bold text-gray-900 mb-4 mt-8">
                {t('privacySection6Title')}
              </h2>
              <p className="text-gray-700 leading-relaxed mb-6">
                {t('privacySection6Content')}
              </p>

              <h2 className="text-2xl font-bold text-gray-900 mb-4 mt-8">
                {t('privacySection7Title')}
              </h2>
              <p className="text-gray-700 leading-relaxed mb-6">
                {t('privacySection7Content')}
              </p>

              <div className="bg-blue-50 border-l-4 border-logo-blue p-6 mt-8 rounded-r-lg">
                <p className="text-gray-800 font-semibold">
                  {t('privacyAgreement')}
                </p>
              </div>

              <div className="mt-10 pt-8 border-t border-gray-200">
                <p className="text-sm text-gray-600">
                  <strong>{t('privacyLastUpdated')}</strong> {t('privacyLastUpdatedDate')}
                </p>
                <p className="text-sm text-gray-600 mt-2">
                  {t('privacyContact')}{' '}
                  <a href="mailto:info@thevisagram.ae" className="text-logo-blue hover:underline">
                    info@thevisagram.ae
                  </a>
                </p>
              </div>
            </div>

          </div>
        </div>
      </section>

      <Footer />
    </div>
  );
};

export default PrivacyPolicyPage;
